var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighPriorityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.342041,
    y: 13.3345,
    width: 16,
    height: 3,
    fill: "#247BA0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.342041,
    y: 6.83447,
    width: 16,
    height: 3,
    fill: "#247BA0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.342041,
    y: 0.334473,
    width: 16,
    height: 3,
    fill: "#247BA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPriorityIcon);
export default __webpack_public_path__ + "static/media/high_priority_icon.7aedd807e3bf9b5270387cb3fb36f51a.svg";
export { ForwardRef as ReactComponent };